@if ({
  banners: currentBanner$ | async,
  config: carouselConfig$ | async,
  }; as content) {
  <ul class="grid-brands">
    @for (brand of content.banners; track brand) {
      <li>
        <cx-banner [item]="brand"></cx-banner>
      </li>
    }
  </ul>
}
